'use strict';

exports.__esModule = true;
exports['default'] = createAction;
function identity(t) {
  return t;
}

function createAction(type, actionCreator, metaCreator) {
  var finalActionCreator = typeof actionCreator === 'function' ? actionCreator : identity;

  return function () {
    var action = {
      type: type,
      payload: finalActionCreator.apply(undefined, arguments)
    };

    if (typeof metaCreator === 'function') action.meta = metaCreator.apply(undefined, arguments);

    return action;
  };
}

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /root/social-native/socialnative-web/node_modules/redux-actions/lib/createAction.js
// module id = 2553
// module chunks = 69